import baseStyled, { ThemedStyledInterface, keyframes } from "styled-components";
export const theme = {
  font: {
    mainFont: "MainFont",
    styledFont: "StyledFont",
  },
  color: {
    primary: "#0046FE",
    secondary: "#FF5C35",
    header: "#FFFFFF",
    text: "#494949",
    lightText: "#B7B7B7",
    valid: "#0D9353",
    invalid: "#DD3E3E",
    boxConnector: "#FFFFFF",
    scrollbar: "#DD3E3E",
    overlayColor: "rgba(59, 59, 59,0.6)",
  },
  mobileFirst: {
    breakPoint: "768px",
  },
  notebook: {
    breakPoint: "1600px",
  },
  icons: {
    navigationArrow: `${process.env.PUBLIC_URL}/assets/icons/arrowLeft.png`,
    closeCross: `${process.env.PUBLIC_URL}/assets/icons/closeCross.png`,
    boxVisited: `${process.env.PUBLIC_URL}/assets/icons/boxVisited.png`,
    boxLocked: `${process.env.PUBLIC_URL}/assets/icons/boxLocked.png`,
    resourcePdfFile: `${process.env.PUBLIC_URL}/assets/icons/resourcePdfFile.png`,
    resourceHyperLink: `${process.env.PUBLIC_URL}/assets/icons/resourceHyperLink.png`,
    resourceDefaultIcon: `${process.env.PUBLIC_URL}/assets/icons/resourceDefaultIcon.png`,
    rotateScreenIcon:`${process.env.PUBLIC_URL}/assets/icons/rotateScreenIcon.png`,
  },
  footer: {
    height: "10em",
    mobileHeight: "8em",
  },
};
export type Theme = typeof theme;
export const styled = baseStyled as ThemedStyledInterface<Theme>;
export type styledAnimation = typeof keyframes;
export type StyleSheet = { [key: string]: React.CSSProperties };
